import { render } from "./ResponsibleGaming.vue?vue&type=template&id=2a8f51ef"
import script from "./ResponsibleGaming.vue?vue&type=script&lang=js"
export * from "./ResponsibleGaming.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__